import React from "react";
import "../styles/Loader.css";

function LoadingScreen({ progress }) {
  return (
    <div className="containerLoader">
      <div className="textContainer">
        <h1 className="titulo">Processamento de áudio ...</h1>
        <p className="subtitulo">
          O áudio está sendo processado. Isso podea levar até um minuto. Por
          favor, mantenha esta página aberta.
        </p>
      </div>

      <div className="loader-wrapper">
        <div className="loader">
          <svg viewBox="0 0 36 36">
            <path
              className="circle-bg"
              d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle"
              strokeDasharray={`${progress}, 100`}
              d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="20.35" className="percentage" textAnchor="middle">
              {progress}%
            </text>
          </svg>
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;
